module.exports = __webpack_public_path__ + "img/tunisia.c8085fc2.svg";